<template>
  <v-card>
    <v-card-title>{{ $t('Pending team invitations') }}</v-card-title>
    <v-card-subtitle>
      {{ $t('You have been invited to join the following teams, you may choose to accept the invitation or to remove it') }}
    </v-card-subtitle>
    <v-list>
      <v-list-item
        v-for="invitation in invitations"
        :key="invitation.id"
      >
        <v-list-item-content>
          <v-list-item-title>{{ invitation.team.name }}</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn
            :loading="joinTeamForm.processing"
            :disabled="joinTeamForm.processing"
            small
            color="success"
            @click="joinTeam(invitation)"
          >
            {{ $t('Join team') }}
          </v-btn>
        </v-list-item-action>

        <v-list-item-action>
          <v-btn
            :loading="removeInvitationForm.processing"
            :disabled="removeInvitationForm.processing"
            small
            color="error"
            @click="removeInvitation(invitation)"
          >
            {{ $t('Remove') }}
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: {
    invitations: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      joinTeamForm: this.$inertia.form({}),
      removeInvitationForm: this.$inertia.form({})
    }
  },

  methods: {
    joinTeam(invitation) {
      this.joinTeamForm.get(invitation.acceptUrl);
    },

    removeInvitation(invitation) {
      const url = this.route('team-invitations.destroy', invitation.id);
      this.removeInvitationForm.delete(url);
    }
  }
}
</script>